<template>
  <div class="d-flex-column justify-start align-start gap-18">
    <div class="d-flex-column justify-start align-start gap-5">
      <h5 class="t-white font-family-1 title-h5">
        {{ $t("new.traders") }}
      </h5>
      <p class="regular-l font-family-2 t-grey">
        {{ $t("new.select_traders_desc") }}
      </p>
    </div>
    <div
      class="d-flex-column select_honor_picker justify-start align-start gap-24"
    >
      <div class="d-flex-row justify-start md-row-to-col">
        <button
          class="role_picker d-flex-row flex-3 gap-5 medium-l font-family-2"
          v-for="option in extraOptions"
          :key="option"
          :class="[
            checkoutStore.getPackExtraOptions['trader'] === option.id &&
              'selected',
          ]"
          @click="selectTrader(option)"
        >
          {{ option.title }}
          <span class="t-blue"> {{ renderPrice(option) }}</span>
        </button>
      </div>
      <div
        class="d-flex-column justify-start align-start gap-10 armor_type_picker"
        :class="[isPersonalLoot && 'disabled']"
      >
        <label class="medium-m font-family-2 t-grey caps">{{
          $t("new.armor_type")
        }}</label>

        <div class="d-flex-row justify-start md-row-to-col">
          <button
            v-for="option in options"
            class="role_picker d-flex-row flex-3 gap-5 medium-l font-family-2"
            style="padding: 6px 12px"
            :class="[checkoutStore.getArmorType === option.title && 'selected']"
            @click="selectArmor(option.title)"
          >
            {{ option.title }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { calculateCurrency } from "../../../../calculate/calculatePrice";
export default {
  data() {
    return {
      options: [
        {
          id: 1,
          title: this.$t("new.cloth"),
        },
        {
          id: 2,
          title: this.$t("new.leather"),
        },
        {
          id: 3,
          title: this.$t("new.mail"),
        },
        {
          id: 4,
          title: this.$t("new.plate"),
        },
      ],
    };
  },
  computed: {
    extraOptions() {
      if (this.getGamePack?.pack_extra_options)
        return this.getGamePack?.pack_extra_options?.filter(
          (option) => option.description === "loot"
        );
      return [];
    },
    isPersonalLoot() {
      if (!this.checkoutStore.getPackExtraOptions["trader"]) {
        this.selectArmor("");
        return true;
      }
      if (this.checkoutStore.getPackExtraOptions["trader"] === 1) {
        this.selectArmor("");
        return true;
      }
      if (this.checkoutStore.getPackExtraOptions["trader"] !== 1) {
        this.selectArmor(this.$t("new.cloth"));
      }
      return false;
    },
  },
  methods: {
    renderPrice(packOption) {
      if (packOption.type === "free") {
        return "";
      } else if (packOption.type === "variable") {
        return `+${packOption.price}%`;
      } else if (packOption.type === "fixed") {
        return `+${parseFloat(calculateCurrency(packOption.price)).toFixed(2)}${
          this.getUserCurrencyCode
        }`;
      } else {
        return `+${packOption.price}`;
      }
    },
    selectTrader(packOption) {
      this.checkoutStore.setPackExtraOptions({
        trader: packOption.id,
      });
    },
    selectArmor(armorType) {
      this.checkoutStore.setArmorType(armorType);
    },
  },

  setup() {
    // ...mapGetters([
    //   "getGamePack",
    //   "getUserCurrency",
    //   "checkoutStore.getPackExtraOptions",
    //   "getArmorType",
    // ]),
    const { getUserCurrency, getUserCurrencyCode } = useUserStore();
    const { getGamePack } = useGameStore();
    const checkoutStore = useCheckoutStore();
    return {
      getUserCurrency,
      getGamePack,
      checkoutStore,
    };
  },
};
</script>
